import styled, { CSSObject } from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Foundations'
import type { ActionOrientation } from './types'

type FooterProps = {
  orientation: ActionOrientation
}

const flexDirections: Record<ActionOrientation, CSSObject['flexDirection']> = {
  vertical: 'column',
  'horizontal-reverse': 'row-reverse',
}

export const AlertBoxActionsStyled = styled.footer<FooterProps>(({ orientation }: FooterProps) => {
  const isHorizontal = orientation === 'horizontal-reverse'
  const orientationStyling = isHorizontal && {
    '> *': {
      flex: '0 1 50%',
    },
  }

  return {
    display: 'flex',
    flexDirection: flexDirections[orientation],
    gap: spacing.smx1,
    marginTop: spacing.bigx1,
    ...orientationStyling,
  }
})

export const AlertBoxIconStyled = styled.div<{
  alignLeft?: boolean
}>(({ alignLeft }) => ({
  '> *': {
    marginLeft: alignLeft ? 0 : 'auto',
    marginRight: 'auto',
    marginBottom: spacing.md,
  },
}))

export const AlertBoxImageStyled = styled.figure({
  margin: 'calc(-1 * var(--modalPaddingTop)) calc(-1 * var(--modalPaddingLeftRightBottom)) 0',
  marginBottom: 'var(--modalPaddingTop)',
  position: 'relative',

  '> img': {
    objectFit: 'cover',
    width: '100%',
    maxWidth: '100%',
    height: 'auto',
    display: 'block',
  },
})

export const AlertBoxContentStyled = styled.div<{
  alignLeft?: boolean
}>(({ alignLeft }) => ({
  textAlign: alignLeft ? 'left' : 'center',
  '> header h1': {
    color: colors.black,
    fontWeight: font.weight.semibold,
    margin: 0,
    marginBottom: spacing.smx1,
    ...font.size.xl2,
    textAlign: alignLeft ? 'left' : 'center',
  },
  '> div': {
    color: colors.neutral[800],
    ...font.size.lg,
    textAlign: alignLeft ? 'left' : 'center',
  },
}))
